import React from 'react';
import TestingPanel from './TestingPanel';

/**
 * Host for the testing panel (Issue #615, #622).
 * Mounted inline here, but TestingPanel itself (#3015) portals its actual
 * markup straight to document.body — see the comment above TestingPanel's
 * `collapsed` branch for why. Page-content push still works the same way
 * either way: it's driven by a CSS variable TestingPanel sets on
 * document.documentElement (same pattern as HelpPanel), not by DOM nesting.
 *
 * Only renders when VITE_TESTING_PANEL_ENABLED is set.
 */
function TestingPanelHost() {
  if (import.meta.env.VITE_TESTING_PANEL_ENABLED !== 'true') {
    return null;
  }

  return <TestingPanel />;
}

export default TestingPanelHost;
